<template>
  <div class="home qm-page-bg">
    <div class="page-header">
      <div class="header-top">
        <div class="page-title">选择门店</div>
        <div class="location-btn" @click="getUserLocation">
          <van-icon name="location-o" />
          <span>{{ locationText }}</span>
        </div>
      </div>
      <div class="header-controls">
        <div class="city-select qm-glass-card" @click="showCitySelect = true">
          <van-icon name="location" class="city-icon" />
          <span class="city-name">{{ currentCity }}</span>
          <van-icon name="arrow-down" class="arrow-icon" />
        </div>
        <div class="search-box">
          <van-search
            v-model="searchValue"
            placeholder="搜索门店 / 地点"
            shape="round"
            @input="onSearch"
          />
        </div>
      </div>
    </div>

    <div class="shop-list">
      <van-list v-model="loading" :finished="true" finished-text="— 已加载全部门店 —">
        <div
          class="shop-item"
          v-for="shop in shopList"
          :key="shop.shopDetail.id"
          @click="getShopMenu(shop.shopDetail)"
        >
          <div class="shop-card qm-glass-card">
            <div class="shop-left">
              <div class="shop-avatar">
                <van-icon name="shop-o" />
              </div>
            </div>
            <div class="shop-right">
              <div class="shop-header">
                <span class="name">{{ shop.shopDetail.name }}</span>
                <span class="distance">{{ shop.shopDetailDistance }}</span>
              </div>
              <div class="shop-tags">
                <span class="tag hall">堂食</span>
                <span class="tag takeaway" v-if="shop.shopDetail.isTakeout === 1">外卖</span>
              </div>
              <p class="address">{{ shop.shopDetail.address }}</p>
              <p class="business-time">
                <van-icon name="clock-o" />
                {{ shop.businessTimes }}
              </p>
            </div>
            <div class="shop-arrow">
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
      </van-list>
    </div>

    <van-popup
      v-model="showCitySelect"
      position="right"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="city-select-page qm-page-bg">
        <van-nav-bar
          title="选择城市"
          left-arrow
          class="qm-nav-bar"
          @click-left="showCitySelect = false"
        />
        <van-index-bar :index-list="indexList" class="city-list-component">
          <div v-for="(cities, letter) in groupedCities" :key="letter">
            <van-index-anchor :index="letter" />
            <van-cell
              v-for="city in cities"
              :key="city.code"
              :title="city.city"
              @click="selectCity(city.city)"
            />
          </div>
        </van-index-bar>
      </div>
    </van-popup>
  </div>
</template>

<script>
import areaData from "@/assets/area.json";
import request from "@/utils/request";

export default {
  name: "HomePage",
  async created() {
    // 调用接口获取PCD IDs，并等待它完成
    await this.getPcdIds();
    // 先通过IP定位获取大致位置
    await this.getIpLocation();
  },
  data() {


    return {
      currentCity: "广州市",
      currentCityInfo: this.getCityInfo("广州市"), // 默认广州市的信息
      searchValue: "",
      searchTimer: null, // 添加防抖定时器
      showCitySelect: false,
      indexList: [], // 初始化为空，将由接口数据生成
      groupedCities: {}, // 初始化为空，将由接口数据生成
      allowedCityIds: [], // 用于存储从接口获取的城市ID列表
      shopList: [],
      loading: false,
      currentShop: null, // 添加当前选中的店铺
      userLocation: null, // 用户定位信息
      locationText: "定位", // 定位按钮文字
    };
  },
  mounted() {
    // 页面加载时默认搜索广州市的店铺 (调用已移至 created)
    // this.searchShops()
  },
  methods: {
    getCityInfo(cityName) {
      // 处理城市名称，统一加上"市"后缀（如果没有的话）
      const normalizedCityName = cityName.endsWith("市")
        ? cityName
        : `${cityName}市`;
      const cityInfo = areaData.cityList.find(
        (city) => city.city === normalizedCityName || city.city === cityName
      );
      if (cityInfo) {
        return {
          code: cityInfo.code,
          lng: cityInfo.lng,
          lat: cityInfo.lat,
        };
      }
      // 默认广州市的信息
      return {
        code: "440100",
        lng: 113.24427795410156,
        lat: 23.1258602142334,
      };
    },
    // 过滤城市列表 (将被移除)
    // filterCities(cityList) { ... }

    selectCity(city) {
      // 检查城市是否可选
      const cityName = typeof city === "string" ? city : city.city;
      const cityInfo = areaData.cityList.find((c) => c.city === cityName);

      if (!cityInfo || !this.allowedCityIds.includes(cityInfo.code)) {
        this.$toast("暂不支持该城市");
        return;
      }

      this.currentCity = cityName;
      this.currentCityInfo = this.getCityInfo(cityName);
      console.log("选择城市：", cityName, "城市信息：", this.currentCityInfo);
      this.showCitySelect = false;
      // 切换城市后重新搜索店铺
      this.searchShops();
    },
    groupCitiesByInitial(cityList, indexList) {
      const grouped = {};
      indexList.forEach((letter) => {
        grouped[letter] = cityList.filter((city) => city.initial === letter);
      });
      return grouped;
    },
    onSearch() {
      // 使用防抖，避免频繁请求
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.searchShops();
      }, 300);
    },
    async getPcdIds() {
      console.log("1");
      
      try {
        const config = this.$store.state.appConfig;
        if (!config) {
          console.error("应用配置尚未加载");
          return;
        }

        const params = {
          appid: config.appid,
          storeId: config.storeId,
        };

        console.log("正在请求PCD IDs，参数：", params);
        const response = await request.post("/qimai/get-pcd-ids", params);
        console.log("获取到的城市Code列表：", response);

        // 1. 从接口获取纯城市ID列表
        const allowedCityCodes = response.data
        if (!Array.isArray(allowedCityCodes)) {
          console.error("从 /get-pcd-ids 获取的城市ID列表格式不正确");
          return;
        }
        this.allowedCityIds = allowedCityCodes;

        // 2. 根据 code 列表过滤本地 area.json 数据
        const filteredCities = areaData.cityList.filter((city) =>
          allowedCityCodes.includes(city.code)
        );

        // 3. 使用过滤后的城市列表来生成UI
        const newIndexList = [
          ...new Set(filteredCities.map((c) => c.initial).filter(Boolean)),
        ].sort();

        this.indexList = newIndexList;
        this.groupedCities = this.groupCitiesByInitial(
          filteredCities,
          newIndexList
        );

        // 检查广州市是否在允许的城市列表中
        const guangzhouCode = "440100";
        if (
          !allowedCityCodes.includes(guangzhouCode) &&
          filteredCities.length > 0
        ) {
          // 如果广州市不在列表中，则默认选择第一个城市
          const defaultCity = filteredCities[0];
          this.currentCity = defaultCity.city;
          this.currentCityInfo = this.getCityInfo(defaultCity.city);
          console.log(
            `广州市未授权，已自动切换到默认城市：${this.currentCity}`
          );
          // 注意：这里的 searchShops 调用将由 created 钩子统一处理，避免重复调用
        }
      } catch (error) {
        console.error("获取PCD IDs失败：", error);
      }
    },
    async searchShops() {
      try {
        this.loading = true;
        const config = this.$store.state.appConfig;
        if (!config) {
          console.error("应用配置尚未加载，无法搜索店铺");
          this.loading = false;
          return;
        }

        const params = {
          nameOrAddress: this.searchValue.trim(),
          cityId: this.currentCityInfo.code,
          pageSize: 20,
          page: 1, // 参数名从 pageNo 改为 page
          appid: config.appid, // 添加 appid
          storeId: config.storeId, // 添加 storeId
          dataId: config.dataId || "", // 安全地处理 dataId
          longitude: this.userLocation ? this.userLocation.longitude : 113.26435852050781,
          latitude: this.userLocation ? this.userLocation.latitude : 23.129079818725586,
        };
        console.log("搜索店铺参数：", params);
        // 将接口地址从 /shops/search 改为 /shop-list
        let response = await request.post("/qimai/shop-list", params);
        console.log("response",response);
        
        // if(response){
        //   response = response.data
        // }

        console.log("店铺接口返回数据：", response);
        if (response.code == 0) {
          this.shopList = response.data.data || [];
          console.log("获取到的店铺列表：", this.shopList);
        } else {
          console.error("获取店铺列表失败：", response.msg);
        }
      } catch (error) {
        console.error("搜索店铺出错：", error);
      } finally {
        this.loading = false;
      }
    },
    formatBusinessTime(time) {
      if (!time) return "";
      // 直接返回已格式化的时间字符串
      return time;
    },
    getShopMenu(shopDetail) {
      // 直接跳转到商品列表页，使用 query 传递店铺基本信息
      this.$router.push({
        path: "/goods-list",
        query: {
          shopId: shopDetail.id,
          shopName: shopDetail.name,
          shopAddress: shopDetail.address,
          shopTel: shopDetail.contactPhone,
          shopLongitude: shopDetail.lng,
          shopLatitude: shopDetail.lat,
        },
      });
    },
    // 通过IP定位获取城市和大致位置（必须调用，用于确定城市）
    async getIpLocation() {
      try {
        this.$toast.loading({
          message: '定位中...',
          forbidClick: true,
          duration: 0
        });
        
        const response = await request.post('/mx/ip-location');
        this.$toast.clear();
        
        if (response && response.success) {
          const { location, ad_info } = response.data;
          console.log('IP定位结果：', response.data);
          
          // 先保存IP定位的坐标（作为默认值）
          this.userLocation = {
            latitude: location.lat,
            longitude: location.lng
          };
          
          // 根据ad_info中的adcode匹配城市（腾讯返回的是adcode，如440100）
          const cityCode = String(ad_info.adcode); // 转为字符串
          const cityName = ad_info.city;
          
          console.log('腾讯定位城市码：', cityCode, '城市名：', cityName);
          
          // 检查该城市是否在允许列表中
          // 优先用adcode匹配，如果没有再用城市名匹配
          let matchedCity = areaData.cityList.find(city => city.code === cityCode);
          
          // 如果没匹配到，再用城市名匹配（去掉
          
          if (matchedCity && this.allowedCityIds.includes(matchedCity.code)) {
            console.log('IP定位匹配到允许的城市：', matchedCity.city);
            this.currentCity = matchedCity.city;
            this.currentCityInfo = {
              code: matchedCity.code,
              lng: location.lng,
              lat: location.lat
            };
            this.locationText = matchedCity.city;
          } else {
            console.log('IP定位城市不在允许列表中，使用默认城市');
            this.locationText = "定位";
          }
          
          // 先使用IP定位搜索门店
          await this.searchShops();
          
          // 然后询问是否允许更精确的浏览器定位（只更新经纬度，不改变城市）
          this.askForPreciseLocation();
        } else {
          console.error('IP定位失败：', response?.message);
          // IP定位失败，使用默认城市并询问浏览器定位
          await this.searchShops();
          this.askForPreciseLocation();
        }
      } catch (error) {
        this.$toast.clear();
        console.error('IP定位请求失败：', error);
        // 请求失败，使用默认城市并询问浏览器定位
        await this.searchShops();
        this.askForPreciseLocation();
      }
    },
    // 询问用户是否允许更精确的浏览器定位（只更新经纬度，不改变城市）
    askForPreciseLocation() {
      this.$dialog.confirm({
        title: '获取更精确位置',
        message: '是否允许获取更精确的位置，以显示附近的门店？',
        confirmButtonText: '允许',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.getBrowserLocation();
        })
        .catch(() => {
          // 用户拒绝，保持IP定位的经纬度（已经搜索过了）
          this.$toast('使用IP定位结果');
        });
    },
    // 获取浏览器定位（只更新经纬度，不改变城市）
    getBrowserLocation() {
      if (navigator.geolocation) {
        this.$toast.loading({
          message: '精确定位中...',
          forbidClick: true,
          duration: 0
        });
        
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.$toast.clear();
            const { latitude, longitude } = position.coords;
            console.log('浏览器定位成功：', { latitude, longitude });
            
            // 只更新为更精确的坐标，城市保持不变
            this.userLocation = {
              latitude: latitude,
              longitude: longitude
            };
            
            this.$toast.success('定位更新成功');
            // 使用更精确的坐标重新搜索（城市不变）
            this.searchShops();
          },
          (error) => {
            this.$toast.clear();
            console.error('浏览器定位失败：', error);
            // 浏览器定位失败，保持IP定位的经纬度
            this.$toast('使用IP定位结果');
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        );
      } else {
        this.$toast('浏览器不支持定位，使用IP定位结果');
      }
    },
    // 手动点击定位按钮重新定位
    getUserLocation() {
      this.getIpLocation();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  padding: 20px 16px 12px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--qm-border);

  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .page-title {
      font-size: 22px;
      font-weight: 700;
      color: var(--qm-text-primary);
      letter-spacing: 1px;
    }

    .location-btn {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding: 6px 12px;
      color: var(--qm-accent);
      background: rgba(245, 166, 35, 0.1);
      border: 1px solid rgba(245, 166, 35, 0.25);
      border-radius: var(--qm-radius-xl);
      white-space: nowrap;
      cursor: pointer;

      .van-icon {
        margin-right: 4px;
        font-size: 13px;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .header-controls {
    display: flex;
    align-items: center;
    gap: 10px;

    .city-select {
      display: flex;
      align-items: center;
      padding: 8px 14px;
      white-space: nowrap;
      cursor: pointer;
      flex-shrink: 0;

      .city-icon {
        color: var(--qm-accent);
        font-size: 14px;
        margin-right: 4px;
      }

      .city-name {
        font-size: 14px;
        font-weight: 600;
        color: var(--qm-text-primary);
      }

      .arrow-icon {
        margin-left: 4px;
        font-size: 10px;
        color: var(--qm-text-muted);
      }
    }

    .search-box {
      flex: 1;
      min-width: 0;

      :deep(.van-search) {
        padding: 0;
        background: transparent;
      }
    }
  }
}

.city-select-page {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .city-list-component {
    flex: 1;
    overflow-y: auto;
  }

  :deep(.van-cell) {
    text-align: left;
    color: var(--qm-text-primary);

    &::after {
      border-color: var(--qm-border);
    }

    &:active {
      background: var(--qm-bg-card-hover);
    }
  }
}

.shop-list {
  padding: 12px 16px 24px;
  min-height: calc(100vh - 120px);

  .shop-item {
    margin-bottom: 12px;
  }

  .shop-card {
    display: flex;
    align-items: center;
    padding: 16px;
    cursor: pointer;
    transition: var(--qm-transition);
    gap: 14px;

    &:active {
      background: var(--qm-bg-card-hover);
      border-color: var(--qm-border-active);
    }

    .shop-left {
      flex-shrink: 0;

      .shop-avatar {
        width: 52px;
        height: 52px;
        border-radius: var(--qm-radius-md);
        background: linear-gradient(135deg, rgba(245, 166, 35, 0.2), rgba(124, 111, 247, 0.2));
        border: 1px solid var(--qm-border);
        display: flex;
        align-items: center;
        justify-content: center;

        .van-icon {
          font-size: 24px;
          color: var(--qm-accent);
        }
      }
    }

    .shop-right {
      flex: 1;
      min-width: 0;
      text-align: left;

      .shop-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 6px;

        .name {
          font-size: 16px;
          font-weight: 600;
          color: var(--qm-text-primary);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }

        .distance {
          color: var(--qm-accent);
          font-size: 13px;
          font-weight: 500;
          margin-left: 8px;
          white-space: nowrap;
        }
      }

      .shop-tags {
        margin-bottom: 6px;

        .tag {
          display: inline-block;
          padding: 2px 8px;
          margin-right: 6px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 500;
        }

        .hall {
          color: #16a34a;
          background: rgba(34, 197, 94, 0.1);
          border: 1px solid rgba(34, 197, 94, 0.2);
        }

        .takeaway {
          color: var(--qm-secondary-light);
          background: rgba(124, 111, 247, 0.08);
          border: 1px solid rgba(124, 111, 247, 0.2);
        }
      }

      .address {
        font-size: 12px;
        color: var(--qm-text-secondary);
        margin-bottom: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .business-time {
        font-size: 12px;
        color: var(--qm-text-muted);
        margin: 0;
        display: flex;
        align-items: center;
        gap: 4px;

        .van-icon {
          font-size: 12px;
        }
      }
    }

    .shop-arrow {
      flex-shrink: 0;
      color: var(--qm-text-muted);
      font-size: 14px;
    }
  }
}
</style> 